import React, { useEffect, useState } from "react";
import { useNavigate, Link } from "react-router-dom";
import { Button, Container, Card } from "react-bootstrap";
import { getVendor, deleteVendor } from "../../store/slices/vendor";
import DeleteModal from "./deletepopup";
import { useDispatch, useSelector } from "react-redux";
import { FaEdit, FaTrash } from "react-icons/fa";

export default function Vendorlist() {
  const dispatch = useDispatch();
  const navigate = useNavigate();

  const { vendorList = [], loading } = useSelector((state) => state.vendor);

  const [showDelete, setShowDelete] = useState(false);
  const [selectedId, setSelectedId] = useState(null);
  const [deleteStatus, setDeleteStatus] = useState("confirm");

  const [currentPage, setCurrentPage] = useState(1);
  const itemsPerPage = 10;

  useEffect(() => {
    dispatch(getVendor({ page: currentPage, limit: 10 }));
  }, [dispatch, currentPage]);

  // handledelete
  const handleConfirmDelete = async () => {
    try {
      setDeleteStatus("loading");

      await dispatch(deleteVendor(selectedId)).unwrap();

      setDeleteStatus("success");

      setTimeout(() => {
        setShowDelete(false);
        setDeleteStatus("confirm");
      }, 1500);
    } catch (error) {
      setDeleteStatus("confirm");
    }
  };

  console.log(vendorList.total);
  const totalPages = Math.ceil(vendorList.total / itemsPerPage);

  const currentVendors = vendorList?.vendors || [];

  const changePage = (pageNumber) => {
    if (pageNumber >= 1 && pageNumber <= totalPages) {
      setCurrentPage(pageNumber);
    }
  };

  return (
    <>
      <div className="breadcrumb-bar mb-2">
        <div className="breadcrumb-left">
          <Link to="/hotel/home" className="breadcrumb-link active">
            Home
          </Link>

          <span className="breadcrumb-separator">|</span>

          <span
            className="breadcrumb-link inactive"
            onClick={() => navigate("/hotel/Vendor")}
          >
            Service Providers
          </span>
        </div>

        <Button
          className="add-outlet-btn"
          onClick={() => navigate("/hotel/addvendor")}
        >
          + Add New
        </Button>
      </div>
      <Container fluid className="mb-5">
        <Card className="table-border">
          <Card.Body>
            <div className="guests-table-wrapper common-table-wrapper">
              <table className="table guests-table common-table align-middle">
                <thead>
                  <tr>
                    <th className="text-center">#</th>
                    <th className="text-center">Name</th>
                    <th className="text-center">Contact Person</th>
                    <th className="text-center">Mobile</th>
                    <th className="text-center">Email</th>
                    <th className="text-center">Services</th>
                    <th className="text-center">Action</th>
                  </tr>
                </thead>

                <tbody>
                  {loading
                    ? [...Array(6)].map((_, index) => (
                        <tr key={index}>
                          <td className="text-center">
                            <div className="skeleton skeleton-text small"></div>
                          </td>

                          <td className="text-center">
                            <div className="skeleton skeleton-image"></div>
                          </td>

                          <td className="text-center">
                            <div className="skeleton skeleton-text"></div>
                          </td>

                          <td className="text-center">
                            <div className="d-flex justify-content-center gap-2">
                              <div className="skeleton skeleton-btn"></div>
                              <div className="skeleton skeleton-btn"></div>
                            </div>
                          </td>
                        </tr>
                      ))
                    : currentVendors.map((vendor, index) => (
                        <tr key={vendor._id}>
                          <td className="text-center">
                            {(currentPage - 1) * itemsPerPage + index + 1}
                          </td>

                          <td className="text-center">{vendor.name}</td>

                          <td className="text-center">
                            {vendor.contactPerson}
                          </td>

                          <td className="text-center">{vendor.mobileNumber}</td>

                          <td className="text-center">{vendor.email}</td>
                          <td className="text-center">
                            {vendor.services?.join(", ")}
                          </td>

                          <td className="text-center">
                            <div className="action-btn-group d-flex justify-content-center gap-2">
                              {/* Edit */}
                              <button
                                onClick={() =>
                                  navigate(`/hotel/editvendor/${vendor._id}`)
                                }
                                className="action-btn edit-btn"
                              >
                                <FaEdit size={14} />
                              </button>

                              {/* Delete */}
                              <button
                                className="action-btn delete-btn"
                                onClick={() => {
                                  setSelectedId(vendor._id);
                                  setShowDelete(true);
                                }}
                              >
                                <FaTrash size={14} />
                              </button>
                            </div>
                          </td>
                        </tr>
                      ))}
                </tbody>
              </table>
            </div>

            {/* Pagination */}
            {totalPages > 1 && (
              <div className="d-flex justify-content-end mt-3 gap-2">
                <Button
                  size="sm"
                  variant="outline-secondary"
                  onClick={() => changePage(currentPage - 1)}
                  disabled={currentPage === 1}
                  className="previous-btn"
                >
                  Prev
                </Button>

                {[...Array(totalPages)].map((_, i) => (
                  <button
                    key={i}
                    size="sm"
                    variant={
                      currentPage === i + 1 ? "primary" : "outline-secondary"
                    }
                    onClick={() => changePage(i + 1)}
                    className={`button-between ${
                      currentPage === i + 1 ? "active-page" : ""
                    }`}
                  >
                    {i + 1}
                  </button>
                ))}

                <button
                  size="sm"
                  variant="outline-secondary"
                  onClick={() => changePage(currentPage + 1)}
                  disabled={currentPage === totalPages}
                  className="next-btn"
                >
                  Next
                </button>
              </div>
            )}
          </Card.Body>
        </Card>
      </Container>
      <DeleteModal
        show={showDelete}
        onHide={() => setShowDelete(false)}
        onConfirm={handleConfirmDelete}
        status={deleteStatus}
      />
    </>
  );
}
